import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CustomerAddressList } from 'src/app/models/customer/customer.model';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { CustomerService } from 'src/app/services/customer.service';
import { CustomerAddressDeleteComponent } from '../customer-address-delete/customer-address-delete.component';
import { CustomerAddressUpdateComponent } from '../customer-address-update/customer-address-update.component';

@Component({
  selector: 'app-customer-address-list',
  templateUrl: './customer-address-list.component.html',
  styleUrls: ['./customer-address-list.component.css']
})
export class CustomerAddressListComponent implements OnInit {

  customerListVM: CustomerAddressList = new CustomerAddressList();
  Loader: boolean = false;

  constructor(private _customerService: CustomerService, private modalService: NgbModal, private localstorage: LocalstorageService) {
    this.localstorage.setMenu("2");
   }

  ngOnInit() {
    this.CustomerAddressList();
  }

  CustomerAddressList() {
    this.Loader = true;
    this._customerService.GetCustomerAddressList().subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.Loader = false;
        this.customerListVM.CustomerList = responseBody.responseData;
      } (err) => {
        this.Loader = false;
      }
    });
  }
  DeleteAddress(addressDelete) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this._customerService.passId(addressDelete.id);
    let modalRef = this.modalService.open(CustomerAddressDeleteComponent, modalConfig);
    modalRef.result.then(() => {
    }, (reason) => {
      this.CustomerAddressList();
    })
  }
  customerAddressUpdate(addressUpdate) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this._customerService.passId(addressUpdate.id);
    let modalRef = this.modalService.open(CustomerAddressUpdateComponent, modalConfig);
    modalRef.result.then(() => {
    }, (reason) => {
      this.CustomerAddressList();
    });
  }
}
